
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.688 2A9.686 9.686 0 002 11.688a9.686 9.686 0 009.688 9.687 9.686 9.686 0 009.687-9.688A9.686 9.686 0 0011.687 2zm0 3.75a3.438 3.438 0 110 6.875 3.438 3.438 0 010-6.875zm0 13.438a7.485 7.485 0 01-5.723-2.665c.734-1.382 2.172-2.335 3.848-2.335.093 0 .187.015.277.042.508.165 1.039.27 1.598.27.558 0 1.093-.105 1.597-.27a.954.954 0 01.277-.043c1.676 0 3.114.954 3.848 2.336a7.486 7.486 0 01-5.723 2.665z","fill":"#999"}})])
          )
        }
      }
    